import { IUserBase, IUserOnboardBase, OnboardType } from '../../models/users';
import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ISetUserOnboardsVenture extends IVentureBase {
  experienceLevels: IVentureExperienceLevelBase[];
}

interface ISetUsersOnboardingServiceResponse extends IUserOnboardBase {
  user: IUserBase;
  venture: ISetUserOnboardsVenture;
}

interface ISetUsersOnboardingService {
  experience?: number;
  onboardId: string;
  onboardType?: OnboardType;
}

const setUsersOnboardingService = async ({
  experience,
  onboardId,
  onboardType,
}: ISetUsersOnboardingService): Promise<ISetUsersOnboardingServiceResponse> => {
  const { data } =
    await jhsfBookingsApi.put<ISetUsersOnboardingServiceResponse>(
      `/users/onboards/${onboardId}`,
      {
        experience,
        onboardType,
      },
    );

  return data;
};

export default setUsersOnboardingService;
